module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-ThinItalic.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-ThinItalic.ttf
// module id = 73
// module chunks = 8